import SidebarDragger from "./SidebarDragger";
import Sidebar from "./Sidebar";
import { useState } from "react";

export default function SidebarCon({ myCatList, setMyCatList, userCatList, setUserCatList, isChangingOrder, setIsChangingOrder }) {
	const [opened, setOpened] = useState({value: true, count: 0});

	return (
		<>
			<SidebarDragger opened={opened} setOpened={setOpened}></SidebarDragger>
			<Sidebar myCatList={myCatList} setMyCatList={setMyCatList} userCatList={userCatList} setUserCatList={setUserCatList} opened={opened} setOpened={setOpened} isChangingOrder={isChangingOrder} setIsChangingOrder={setIsChangingOrder}></Sidebar>
		</>
	);
}
